import { createTheme, useTheme } from "@mui/material/styles";
import type { PaletteColor } from "@mui/material/styles";

import type { TCriticality, TVerdictKey } from "@mnemonic/mui/styles";
import { createMnemonicDarkTheme } from "@mnemonic/mui/styles";

declare module "@mui/material/styles" {
  /**
   * This will add the tertiary colors array to th  e
   * Theme type exported by material
   */
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Palette {
    tertiary: Array<PaletteColor>;
    criticality?: { low: PaletteColor; medium: PaletteColor; high: PaletteColor; critical: PaletteColor };
    getTertiaryColor: (index: number) => PaletteColor;
    getCriticalityColor: (criticality: number | TCriticality | string) => PaletteColor;
  }

  // allow configuration using `createMuiTheme`
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface PaletteOptions {
    tertiary?: Array<PaletteColor>;
    criticality?: { low: PaletteColor; medium: PaletteColor; high: PaletteColor; critical: PaletteColor };
    getCriticalityColor?: (criticality: number | TCriticality | string) => PaletteColor;
    getTertiaryColor?: (index: number) => PaletteColor;
    getVerdictColor?: (key: TVerdictKey) => PaletteColor;
  }
}

export const useLeftSidebarTheme = () => {
  // Get the theme that is defined higher than the menu in the render tree.
  const parentTheme = useTheme();

  // The LeftSidebar is always dark.
  const darkTheme = createMnemonicDarkTheme();

  const theme = createTheme(darkTheme, {
    palette: {
      // The dark theme uses a #3DB6B9 (cyan/blue) as primary. In the menu we want to use white.
      primary: { main: parentTheme.palette.common.white },
      // Set the orange/secondary color in the menu to match the orange/secondary color in the page.
      secondary: parentTheme.palette.secondary,
    },
  });
  return { theme, parentTheme };
};
